<template>
	<div>
		<!-- <div
      style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
      v-if="loaderStatus"
    >
      <Spinner />
    </div> -->
		<div class="height-100dvh">
			<div class="mob-back-header">
				<img
					@click="$router.go(-1)"
					class="mr-3"
					src="../../assets/mobile/assprog/mobileBackArrow.svg"
					alt=""
				/>
				Assessment Mark
			</div>
			<div class="mob-back-body">
				<div class="mob-assess-top-overflow">
					<div class="mob-white-card">
						<template v-if="selectedAssessment.companyName">
							<div class="mob-small-head">Company</div>
							<div class="mb-mobile-txt-2 mt-1 text-truncate">
								{{ selectedAssessment.companyName }}
							</div>
							<div class="mob-small-head mt-2">Job Title</div>
							<div class="mb-mobile-txt-2 mt-1 text-truncate">
								{{ selectedAssessment.jobName || "NA" }}
							</div>
						</template>
						<template v-else>
							<div class="mob-small-head mt-2">Organiser</div>
							<div class="mb-mobile-txt-2 mt-1 text-truncate">
								{{ selectedAssessment.organiser }}
							</div>
						</template>
						<div class="border-bottom mt-3 mb-3"></div>
						<div class="mob-small-head mt-2">Topic name</div>
						<div class="mb-mobile-txt-2 mt-1 text-truncate">
							{{ selectedAssessment.topicName }}
						</div>
						<div class="mob-small-head mt-2">Test name</div>
						<div class="mb-mobile-txt-2 mt-1 text-truncate">
							{{ selectedAssessment.testName }}
						</div>
						<div class="mob-small-head mt-2">Total No.of Attempts</div>
						<div class="mb-mobile-txt-2 mt-1 text-truncate">
							{{ selectedAssessment.maxnoattempts }}
						</div>
						<div
							class="border-bottom mt-3 mb-3"
							v-if="selectedAssessment.assessmentResponse[0].evaluation"
						></div>
						<ProgressBar
							:assessment="selectedAssessment"
							v-if="selectedAssessment.assessmentResponse[0].evaluation"
						/>
					</div>

					<!-- ================= RECENT ATTEMPT ================= -->

					<div
						v-if="attemptedAttempts.length"
						:class="
							expandedAttempt === attemptedAttempts[0].attemptNo
								? 'asp-new-openbox asp-open-box'
								: 'asp-closed-box'
						"
						class="mb-2 mt-2"
					>
						<div
							@click="
								attemptedAttempts[0].evaluation &&
									toggleAttempt(attemptedAttempts[0].attemptNo)
							"
							class="d-flex align-items-center justify-content-between position-relative asp-newpadding asp-top-open-box"
							:class="{
								pointer: attemptedAttempts[0].evaluation,
							}"
						>
							<div>
								<div class="d-flex align-items-center">
									<div class="asp-black-txt">
										Attempt
										{{ attemptedAttempts[0].attemptNo }}
									</div>
									<div
										class="recent-attempt-tag text-white fam-lato fs-11 fw-B text-italic ml-1"
									>
										Recent Attempts
									</div>
								</div>
								<div
									v-if="!attemptedAttempts[0].evaluation"
									class="d-flex align-items-center justify-content-between w-100"
								>
									<div class="asp-grey-txt-3 mt-2">Test Taken on :</div>
								</div>
							</div>
							<div class="d-flex align-items-center">
								<div v-if="!attemptedAttempts[0].evaluation">
									<div class="asp-grey-txt-3 fw-M fam-mont color-595959">
										Not Yet Evaluated
									</div>
									<div class="mb-mobile-txt mt-2 text-end">
										{{ formatDate(attemptedAttempts[0].createdAt) }}
									</div>
								</div>
								<span
									class="asp-greentxt mr-4"
									v-else-if="attemptedAttempts[0].resultPerAttemptStatusCode"
								>
									PASSED
								</span>
								<span class="asp-redtxt mr-4" v-else> FAILED </span>

								<img
									v-if="attemptedAttempts[0].evaluation"
									src="../../assets/newdesign/assessPro/bluedownarrow.svg"
									alt=""
								/>
							</div>
						</div>

						<b-collapse
							:visible="expandedAttempt === attemptedAttempts[0].attemptNo"
							v-if="attemptedAttempts[0].evaluation"
						>
							<div
								class="d-flex justify-content-between align-items-center px-2 new-border-bottom-blue"
							>
								<div class="asp-grey-txt-3">Test Taken on :</div>
								<div class="mb-mobile-txt">
									{{ formatDate(attemptedAttempts[0].createdAt) }}
								</div>
							</div>

							<div v-if="attemptedAttempts[0].evaluation">
								<div class="asp-blue-bottom py-2 pl-2 pr-0">
									<div
										class="asp-blue-txt-2 d-flex align-items-center justify-content-between"
									>
										<div class="d-flex align-items-center">
											Total Marks :&nbsp;
											{{ attemptedAttempts[0].totalMarksScoredPerAttempt }}/
											{{
												roundToTwo(attemptedAttempts[0].totalMarksPerAttempt)
											}}
										</div>
										<div class="d-flex align-items-center mr-2">
											Passing Percentage (%) :&nbsp;
											{{ attemptedAttempts[0].passingPercentage }}/100
										</div>
									</div>

									<div
										class="d-flex align-items-center justify-content-between asp-small-grey-txt mt-2"
										v-if="attemptedAttempts[0].testResponse.length"
									>
										<div>Sections</div>
										<div class="mr-2">Marks</div>
									</div>

									<div class="asp-right-modal-overflow pr-1 mr-1">
										<div
											v-for="(section, index) in attemptedAttempts[0]
												.testResponse"
											:key="index"
											class="d-flex align-items-center justify-content-between mt-2"
										>
											<div class="mb-mobile-txt-2 text-truncate w-75">
												{{ section.sectionName }}
											</div>
											<div class="asp-blue-txt-3">
												{{ roundToTwo(section.sectionMarks) }}/{{
													roundToTwo(section.serctionTotalMarks)
												}}
											</div>
										</div>
									</div>
								</div>

								<div
									class="detailed-report-box fw-M fs-13 fam-mont text-white d-flex justify-content-center align-items-center pointer"
									@click="gotoasmntReport(attemptedAttempts[0])"
								>
									View Detailed Report
									<img
										class="ml-2"
										src="../../assets/img/whiteforwardarw.svg"
										alt=""
									/>
								</div>
							</div>

							<div class="asp-blue-bottom py-2 pl-2 pr-0" v-else>
								Yet to evaluate
							</div>
						</b-collapse>
					</div>
					<!-- ================= DIVIDER ================= -->
					<div
						v-if="attemptedAttempts.length > 1"
						class="position-relative py-2"
					>
						<hr style="border-top: 2px solid #8c8c8c" />
						<div class="prevatempt-txt fam-lato fw-M fs-14 color-595959 mx-3">
							Previous Attempts
						</div>
					</div>
					<!-- ================= PREVIOUS ATTEMPTS ================= -->

					<div
						v-for="attempt in attemptedAttempts.slice(1)"
						:key="attempt.attemptNo"
						:class="
							expandedAttempt === attempt.attemptNo
								? 'asp-new-openbox asp-open-box'
								: 'asp-closed-box'
						"
						class="mb-2"
					>
						<div
							@click="attempt.evaluation && toggleAttempt(attempt.attemptNo)"
							class="d-flex align-items-center justify-content-between position-relative asp-newpadding asp-top-open-box"
							:class="{ pointer: attempt.evaluation }"
						>
							<div class="asp-black-txt">Attempt {{ attempt.attemptNo }}</div>

							<div class="d-flex align-items-center">
								<span class="asp-grey-txt-3" v-if="!attempt.evaluation">
									Not Yet Evaluated
								</span>
								<span
									class="asp-greentxt mr-4"
									v-else-if="attempt.resultPerAttemptStatusCode"
								>
									PASSED
								</span>
								<span class="asp-redtxt mr-4" v-else> FAILED </span>

								<img
									v-if="attempt.evaluation"
									src="../../assets/newdesign/assessPro/bluedownarrow.svg"
									alt=""
								/>
							</div>
						</div>

						<b-collapse
							:visible="expandedAttempt === attempt.attemptNo"
							v-if="attempt.evaluation"
						>
							<div
								class="d-flex justify-content-between align-items-center px-2 new-border-bottom-blue"
							>
								<div class="asp-grey-txt-3">Test Taken on :</div>
								<div class="mb-mobile-txt">
									{{ formatDate(attempt.createdAt) }}
								</div>
							</div>

							<div v-if="attempt.evaluation">
								<div class="asp-blue-bottom py-2 pl-2 pr-0">
									<div
										class="asp-blue-txt-2 d-flex align-items-center justify-content-between"
									>
										<div class="d-flex align-items-center">
											Total Marks :&nbsp;
											{{ attempt.totalMarksScoredPerAttempt }}/{{
												roundToTwo(attempt.totalMarksPerAttempt)
											}}
										</div>
										<div class="d-flex align-items-center mr-2">
											Passing Percentage (%) :&nbsp;
											{{ attempt.passingPercentage }}/100
										</div>
									</div>

									<div
										class="d-flex align-items-center justify-content-between asp-small-grey-txt mt-2"
										v-if="attempt.testResponse.length"
									>
										<div>Sections</div>
										<div class="mr-2">Marks</div>
									</div>

									<div class="asp-right-modal-overflow pr-1 mr-1">
										<div
											v-for="(section, index) in attempt.testResponse"
											:key="index"
											class="d-flex align-items-center justify-content-between mt-2"
										>
											<div class="mb-mobile-txt-2 text-truncate w-75">
												{{ section.sectionName }}
											</div>
											<div class="asp-blue-txt-3">
												{{ roundToTwo(section.sectionMarks) }}/{{
													roundToTwo(section.serctionTotalMarks)
												}}
											</div>
										</div>
									</div>
								</div>

								<div
									class="detailed-report-box fw-M fs-13 fam-mont text-white d-flex justify-content-center align-items-center pointer"
									@click="gotoasmntReport(attempt)"
								>
									View Detailed Report
									<img
										class="ml-2"
										src="../../assets/img/whiteforwardarw.svg"
										alt=""
									/>
								</div>
							</div>

							<div class="asp-blue-bottom py-2 pl-2 pr-0" v-else>
								Yet to evaluate
							</div>
						</b-collapse>
					</div>
				</div>
				<!-- Remaining attempts -->
				<div
					class="total-attemptsremain-box d-flex align-items-center justify-content-center"
				>
					<span class="fs-14 fw-LM fam-lato text-darkgrey">
						Total Attempts Remaining:&nbsp;
					</span>
					<span class="fs-16 fw-800 text-blue fam-lato">
						{{ remainingAttemptsCount }}
					</span>
					<span class="fs-16 fw-LM text-darkgrey fam-lato ml-1">
						/ {{ selectedAssessment.config.maxnoattempts }}
					</span>
				</div>
				<div class="mob-footer w-100 mt-2 px-3">
					<div class="mob-cancelBtn w-50 pr-2">
						<b-button class="w-100" @click="$router.go(-1)">Cancel</b-button>
					</div>
					<div class="mob-addBtn w-50 pl-2">
						<b-button
							v-if="selectedAssessment.attemptsLeft == 0"
							class="w-100"
							@click="$router.go(-1)"
							>Okay</b-button
						>
						<b-button v-else class="w-100" @click="viewTestDetails()"
							>Retake Test</b-button
						>
					</div>
				</div>
			</div>
		</div>
		<b-modal
			id="emailmodal"
			v-model="showNotifyMe"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			@hidden="showNotifyMe = false"
		>
			<div class="d-flex flex-column align-items-center justify-content-center">
				<img src="../../assets/newdesign/assessPro/emailNoti.svg" alt="" />
				<div class="text-center asp-black-txt-3 mt-3">
					You will receive an email notification<br />
					shortly
				</div>
				<b-button class="candash-addBtn mt-3" @click="showNotifyMe = false"
					>Okay</b-button
				>
			</div>
		</b-modal>
	</div>
</template>
<script>
import ProgressBar from "@/components/ProgressBar.vue";
import { mapGetters } from "vuex";
export default {
	name: "AssessmentMarksModal",
	data() {
		return {
			expandedAttempt: null,
			isCopied: false,
			isPublic: false,
			showNotifyMe: false,
			isPublicMob: false,
		};
	},
	components: {
		ProgressBar,
	},
	computed: {
		...mapGetters("candidateVUEX", {
			selectedAssessment: "getselectedAssessment",
		}),
		attemptedAttempts() {
			return this.selectedAssessment.assessmentResponse
				.filter((a) => a.attemptNo) // attempted ones
				.sort((a, b) => b.attemptNo - a.attemptNo); // latest first
		},

		remainingAttemptsCount() {
			return (
				this.selectedAssessment.config.maxnoattempts -
				this.selectedAssessment.assessmentResponse.length
			);
		},
	},
	methods: {
		gotoasmntReport(section) {
			this.$router.push({
				name: "AssessmentReport",
				query: {
					testID: this.selectedAssessment.testID,
					groupID: this.selectedAssessment.group.groupID,
					attemptNo: section.attemptNo,
					searchQuery: this.$route.query.searchQuery || "",
					category: this.$route.query.category,
					subCategory: this.$route.query.subCategory,
				},
			});
		},
		viewTestDetails() {
			this.$router.push({
				name: "mobAssessment",
				query: {
					public: this.isPublicMob,
				},
			});
		},
		shortenLink(link) {
			return "https://.../" + link.split("/").slice(-1);
		},
		copyToClipboard(text) {
			this.$copyToClipboard(text);
		},
		formatTime(date) {
			return new Date(date)
				.toLocaleString("en-IN", {
					hour: "numeric",
					minute: "numeric",
					hour12: true,
				})
				.toUpperCase();
		},
		formatDate(date) {
			return new Date(date)
				.toLocaleString("en-IN", {
					day: "2-digit",
					month: "2-digit",
					year: "numeric",
				})
				.replaceAll("/", "-");
		},
		toggleAttempt(no) {
			this.expandedAttempt = this.expandedAttempt === no ? null : no;
		},
		roundToTwo(num) {
			return Math.round(num);
		},
	},
};
</script>
<style scoped>
.mob-assess-top-overflow {
	height: 83.5%;
	overflow: auto;
}
.mob-white-card {
	border-radius: 4px;
	background-color: #ffffff;
	padding: 17px 14px;
}
.total-attemptsremain-box {
	padding: 4px;
	border-radius: 4px 4px 0 0;
	background: #fff6d7;
}
</style>
